const SET_SPECIFIC_LABEL = 'app/SET_SPECIFIC_LABEL';

export default {
  SET_SPECIFIC_LABEL,
};
